import { FC } from 'react';

import { Program } from '../../../forces/channels/channel.types';
import { UnstyledLink } from '../../../router/Link';
import { TvGuideProgramTitle } from '../ShowMorePrograms/TvGuideProgramTitle';

import styles from './TvGuideMiniProgram.module.css';

interface Props {
  program: Program;
  isCurrentProgram?: boolean;
}

export const TvGuideMiniProgram: FC<Props> = ({ program, isCurrentProgram }) => {
  return (
    <UnstyledLink to={program.url} className={styles.link}>
      <TvGuideProgramTitle
        className={styles.content}
        isCurrentProgram={isCurrentProgram}
        program={program}></TvGuideProgramTitle>
    </UnstyledLink>
  );
};
